import { combineReducers } from 'redux';
import catalogReducer from './catalogReducer';
import catalogStyleReducer from './catalogStyleReducer';
import paginationReducer from './paginationReducer';
import searchCatalogReducer from './searchCatalogReducer';
import priceReducer from './priceReducer';

const rootReducer = combineReducers({
  search: searchCatalogReducer,
  catalog: catalogReducer,
  catalogStyle: catalogStyleReducer,
  pagination: paginationReducer,
  price: priceReducer,
});

export default rootReducer;
